module.exports = __webpack_public_path__ + "img/8cd16fa048e8c1b44ef616d983b0bdd6.svg";